import Enumerator from '../global/Enumerator';

export const ticketLoanFeeTypes = [
  'disbursements',
  'commissions',
  'legal_fees',
  'additional_fees'
];

export class TicketLoanFeeType extends Enumerator {
  static default() {
    return this.of('disbursements');
  }
}

TicketLoanFeeType.initEnum({
  disbursements: {
    get id() {
      return 'disbursements';
    },
    get title() {
      return 'Disbursements';
    },
    get weight() {
      return 1;
    }
  },
  commissions: {
    get id() {
      return 'commissions';
    },
    get title() {
      return 'Commissions';
    },
    get weight() {
      return 2;
    }
  },
  legal_fees: {
    get id() {
      return 'legal_fees';
    },
    get title() {
      return 'Legal fees';
    },
    get weight() {
      return 3;
    }
  },
  additional_fees: {
    get id() {
      return 'additional_fees';
    },
    get title() {
      return 'Additional fees';
    },
    get weight() {
      return 4;
    }
  }
});

export default {
  TicketLoanFeeType
};
